import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Functions, httpsCallable } from '@angular/fire/functions';
import { loadStripe, Stripe } from '@stripe/stripe-js'; // <--- Aquí está la función
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class PaymentService {
  private functions = inject(Functions);
  private readonly _http = inject(HttpClient)
  private readonly _url = environment.serverURL

  // Reemplaza con tu "Publishable key" (pk_test_...)
  private stripePromise = loadStripe('pk_live_51TWiZbJuoe8DhOtSmK3yeaCdB5nkN7hsOqu7NXwn025qhu7cKygxhyjl0WzXgkGIFxSmw2fdg2P8ahT8bUh9djTE00AMm2WLDJ');
procesarPago(items: any) {
    console.log('Enviando carrito al servidor:', this._url);

    // Retornamos el observable tal cual
    return this._http.post(`${this._url}/checkout`, { items: items });
  }




}
